import { Link } from 'react-router-dom'
import { Box, Flex, HStack, Text, Tooltip, VStack } from '@chakra-ui/react'
import { CalendarBlank, Monitor, PlusCircle } from '@phosphor-icons/react'

import dateFormat from 'functions/dateFormat'

interface Props {
    event: EventInt
}

type EventType = 'presential' | 'tele'

interface EventInt {
    id: string,
    patient: string,
    medic: string,
    event_type: EventType
    scheduled_to: Date
}

const Event = ({ event }: Props) => {
    return (
        <>
            <HStack w="full" spacing={2} h="auto">
                <Flex justifyContent="center" alignItems="center" minW="50px" h="full">
                    <Tooltip label={event.event_type === 'presential' ? 'Presencial' : 'Tele'}>
                        {event.event_type === 'presential' ? <CalendarBlank size="32" /> : <Monitor size="32" />}
                    </Tooltip>
                </Flex>
                <VStack spacing={2} justifyContent="flex-start" alignItems="flex-start" h="full" w="full">
                    <Text fontSize="md">Agendado para: {dateFormat(event.scheduled_to)}</Text>
                    <Link to=""><Text fontSize="md">Vida: {event.patient}</Text></Link>
                    <Link to=""><Text fontSize="md">Médico: {event.medic}</Text></Link>
                </VStack>
                {/* <Flex justifyContent="center" alignItems="center" h="full">
                    <Link to={`/eventos/${event.id}`} >
                        <Box cursor="pointer">
                            <Tooltip label="Ver agendamento">
                                <PlusCircle size="25" />
                            </Tooltip>
                        </Box>
                    </Link>
                </Flex> */}
            </HStack>
        </>
    )
}

export default Event